// create firestore query based on the filter fields
// Firebase v11 modular SDK
import {
  query,
  where,
  orderBy,
  limit,
  startAfter,
  endAt
} from 'firebase/firestore';
import { numberOfPromptsPerFetch } from './constants';

export const createPromptsQuery = (collectionRef, filter, getState = null) => {
  const {
    iam,
    lookingfor,
    tag,
    creator,
    published,
    sort,
    lastPrompt,
    previousOrNext,
    hide
  } = filter;

  // Build array of query constraints
  const constraints = [];

  // hides the prompt from view, usually because the prompt was flagged
  constraints.push(where('hide', '==', hide));

  if (iam && iam !== 'all') {
    constraints.push(where('iam', '==', iam));
  }
  if (lookingfor && lookingfor !== 'all') {
    constraints.push(where('lookingfor', 'in', [lookingfor, 'all']));
  }
  if (tag && tag !== 'all') {
    constraints.push(where('tagsLower', 'array-contains', tag.toLowerCase()));
  }
  if (creator && creator !== 'all') {
    constraints.push(where('creatorLower', '==', creator.toLowerCase()));
  }
  if (published === true) {
    constraints.push(where('published', '==', published));
  } else if (published === false) {
    constraints.push(where('published', '==', published));
    const userID = getState().auth.currentUser.uid;
    constraints.push(where('creatorID', '==', userID));
  }

  if (sort && sort !== 'none') {
    if (sort === 'hot') {
      constraints.push(orderBy('bumpedAt', 'desc'));
    } else if (sort === 'new') {
      constraints.push(orderBy('publishedAt', 'desc'));
    } else if (sort === 'top') {
      constraints.push(orderBy('lovesCount', 'desc'));
    } else if (sort === 'bump') {
      constraints.push(orderBy('bumpedAt', 'desc'));
    } else if (sort === 'old') {
      constraints.push(orderBy('publishedAt', 'asc'));
    }
  }

  if (lastPrompt && previousOrNext) {
    if (previousOrNext === 'previous') {
      constraints.push(endAt(lastPrompt));
    } else if (previousOrNext === 'next') {
      constraints.push(startAfter(lastPrompt));
    }
  }

  constraints.push(limit(numberOfPromptsPerFetch));

  return query(collectionRef, ...constraints);
};
